module.exports = __webpack_public_path__ + "img/baomoyuan.cac0b16e.png";